module.exports = __webpack_public_path__ + "static/img/kf_code.46f3307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_code.png
// module id = 4IeH
// module chunks = 1